import styled from 'styled-components';
import { Tabs as AntdTabs } from 'antd';

import { breakpoints, colors } from 'theme/variables';

export const Tabs = styled(AntdTabs)<{ noBottomMargin?: boolean }>(
    ({ noBottomMargin }) => `
    width: 100%;

    ${breakpoints.medium} {
        .ant-tabs-nav {
            display: flex;
            justify-content: center;
        }
    }

    && .ant-tabs-nav {
        margin-bottom: ${noBottomMargin ? '0' : '0'} !important;
        padding: 0 16px;
        background: transparent;
    }

    form {
        margin: 0 auto;
    }
`,
);

export const SmallTabs = styled(Tabs)`
    && .ant-tabs-nav {
        margin-bottom: 0 !important;
        background-color: transparent;

        .ant-tabs-tab {
            padding: 10px 4px;
            font-size: 0.84rem;
        }
    }
`;
